import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class HomeController {
    constructor() {
        this.MvSlider();
        this.setMvBanner();

        this.player = null;
        this.youtubeApiLoaded = false;

        // this.setConceptMovie();
        // this.setPopupMovie();
        this.setHeaderLogoVisible();
        setTimeout(() => {
            $('.is-home').addClass('is-show');
        }, 200);

        this.VoiceSlider();
        this.OwnersVoiceSlider();

        this.setVoiceBg();
        this.setHeaderDefaultSet();
        this.setInterviewSlide();
        this.setOwnersVoiceSlide();
        this.setScrollJump();
    }

    MvSlider() {
        let options = {
            loop: true,
            effect: 'fade',
            speed: 2000,
            autoplay: {
                delay: 4300,
            },
        };
        let MvSlider = new Swiper('#js-home-concept__mv-slider', options);
    }

    setMvBanner() {
        let $btn = $('.mainvisual .mainvisual__banner');
        $btn.on('mouseenter', function () {
            $btn.addClass('is-open');
        });
        $btn.on('mouseleave', function () {
            $btn.removeClass('is-open');
        });

        if (window.UA.isSP) {
            $btn.hide();
        }
    }


    setHeaderLogoVisible() {
        let $headerBg = $('#js-global-header');

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 10) {
                $headerBg.addClass('is-visible');
            } else {
                $headerBg.removeClass('is-visible');
            }
        });
    }

    // setConceptMovie() {
    //     gsap.registerPlugin(ScrollTrigger);
    //     const area = document.querySelector('.home-concept__mv');

    //     gsap.to(area, {
    //         opacity: 1,
    //         scrollTrigger: {
    //             trigger: area,
    //             start: 'top bottom',
    //             end: 'bottom bottom',
    //             scrub: 1,
    //         },
    //     });
    // }

    // setPopupMovie() {
    //     let $link = $('#js-home-concept__mv-btn');
    //     let $pop = $('.home-concept__popup');
    //     let $bg = document.getElementById('js-home-concept__mv-video');
    //     let _this = this;

    //     $link.on('click', function (e) {
    //         e.preventDefault();

    //         if (!_this.youtubeApiLoaded) {
    //             let tag = document.createElement('script');
    //             tag.src = 'https://www.youtube.com/iframe_api';
    //             let firstScriptTag = document.getElementsByTagName('script')[0];
    //             firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    //             window.onYouTubeIframeAPIReady = () => {
    //                 _this.player = new YT.Player('js-popup__mv', {
    //                     videoId: $('#js-home-concept__mv-btn').data('yid'),
    //                     events: {
    //                         onReady: function (event) {
    //                             event.target.playVideo();
    //                         },
    //                     },
    //                 });
    //                 _this.youtubeApiLoaded = true;
    //             };
    //         } else if (_this.player && _this.youtubeApiLoaded) {
    //             _this.player.playVideo();
    //         }

    //         $pop.toggleClass('is-open');
    //         $bg.pause();
    //     });

    //     $pop.on('click', function (e) {
    //         e.preventDefault();
    //         // console.log(e.currentTarget);
    //         if ($(e.target).hasClass('is-open')) {
    //             $pop.removeClass('is-open');
    //             _this.player.pauseVideo();
    //             $bg.play();
    //         }
    //     });
    //     $('.common-popup__close').on('click', function (e) {
    //         e.preventDefault();
    //         $pop.removeClass('is-open');
    //         _this.player.pauseVideo();
    //         $bg.play();
    //     });
    // }

    VoiceSlider() {
        let options = {
            loop: !window.UA.isSP,
            loopAdditionalSlides: 4,
            loopFillGroupWithBlank: false,
            centeredSlides: true,
            spaceBetween: window.UA.isSP ? 16 : 64,
            slidesPerView: 'auto',
            speed: window.UA.isSP ? 1000 : 2000,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '#style-detail__next2',
                prevEl: '#style-detail__prev2',
            },
            scrollbar: {
                el: '#style-detail__bar2',
                draggable: false,
            },
            touchAngle: 20,
            
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };

        if ($('.home-voice__slider-item').length < 2) {
            options.centeredSlides = true;
        }
        let voiceSlider = new Swiper('#js-home-voice__slider', options);
        voiceSlider.on('slideChange', function () {
            if (this.realIndex > 0) {
                this.params.autoplay.delay = 5000;
            }
        });
        if (window.UA.isSP) {
            voiceSlider.off('resize');
        }
    }

    setVoiceBg() {
        let controller = new ScrollMagic.Controller();
        let scene = new ScrollMagic.Scene({
            duration: $('.home-voice').height(),
            offset: 250,
            triggerHook: 'onEnter',
            triggerElement: '.home-voice',
            reverse: true,
        }).addTo(controller);
        scene.on('enter', function (event) {
            // console.log("Scene entered.");
        });
        scene.on('leave', function (event) {
            // console.log("Scene left.",  event.progress);
            if (event.progress === 1) {
            }
        });
        scene.on('progress', function (event) {
            // console.log("Scene progress changed to " + event.progress);
            $('.home-voice__bg-mask').css({
                // background: `linear-gradient(180deg, rgba(244, 244, 244, 0) 0%, #F4F4F4 ${event.progress*100}%)`
                background: `rgba(255, 255, 255, ${event.progress})`,
            });
        });
    }

    OwnersVoiceSlider() {
        let options = {
            loop: false,
            loopAdditionalSlides: 4,
            loopFillGroupWithBlank: false,
            centeredSlides: false,
            spaceBetween: window.UA.isSP ? 25 : 20,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '#js-home-ownersvoice__slider-next',
                prevEl: '#js-home-ownersvoice__slider-prev',
            },
            scrollbar: {
                el: '#js-home-ownersvoice__slider-bar',
                draggable: false,
            },
            touchAngle: 20,
            speed: 800,
            on: {
            },
        };

        if ($('.home-ownersvoice__slider-item').length < 2) {
            options.centeredSlides = true;
        }
        let ownersvoiceSlider = new Swiper('#js-home-ownersvoice__slider', options);
        ownersvoiceSlider.on('slideChange', function () {
            if (this.realIndex > 0) {
                this.params.autoplay.delay = 3000;
            }
        });
        $('#js-home-ownersvoice__slider-next').on('click', () => {
            if (ownersvoiceSlider.isEnd === true) {
            }
        });
        if (window.UA.isSP) {
            ownersvoiceSlider.off('resize');
        }
    }

    setHeaderDefaultSet() {
        if ($('.is-home').length) {
            $('.global-header').addClass('is-top-default');
        }
    }

    setInterviewSlide() {
        let options = {
            loop: false,
            loopAdditionalSlides: 1,
            loopFillGroupWithBlank: false,
            centeredSlides: false,
            spaceBetween: (window.UA.isSP) ? 24 : 32,
            slidesPerView: 'auto',
            navigation: {
                nextEl: '#style-detail__other-slide-next',
                prevEl: '#style-detail__other-slide-prev',
            },
            scrollbar: {
                el: '#style-detail__other-slide-bar',
                draggable: false,
            },
            touchAngle: 20,
            speed: 800,
            on: {
            },
        };

        let otherSlider = new Swiper('#js-home-interview-slide', options);
        if (window.UA.isSP) {
            otherSlider.off('resize');
        }
    }
    setOwnersVoiceSlide() {
        let slideCount = document.querySelectorAll('#js-home-owners-slide .swiper-slide').length;
        if (window.UA.isSP) {
            // スマホ幅のとき
            if (slideCount >= 2) {
                let options = {
                    loop: false,
                    loopAdditionalSlides: 1,
                    loopFillGroupWithBlank: false,
                    centeredSlides: false,
                    spaceBetween: 24,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: '#style-detail__other-slide-next2',
                        prevEl: '#style-detail__other-slide-prev2',
                    },
                    scrollbar: {
                        el: '#style-detail__other-slide-bar2',
                        draggable: false,
                    },
                    touchAngle: 20,
                    speed: 800,
                };
                let otherSlider = new Swiper('#js-home-owners-slide', options);
                otherSlider.off('resize');
            } else {
                document.querySelector('#js-home-owners-slide').classList.add('min-slide');
                document.querySelector('#style-detail__other-slide-nav').classList.add('min-slide-nav');
            }
        } else {
            // PC幅のとき
            if (slideCount >= 4) {
                let options = {
                    loop: false,
                    loopAdditionalSlides: 1,
                    loopFillGroupWithBlank: false,
                    centeredSlides: false,
                    spaceBetween: 32,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: '#style-detail__other-slide-next2',
                        prevEl: '#style-detail__other-slide-prev2',
                    },
                    scrollbar: {
                        el: '#style-detail__other-slide-bar2',
                        draggable: false,
                    },
                    touchAngle: 20,
                    speed: 800,
                };
                let otherSlider = new Swiper('#js-home-owners-slide', options);
            } else {
                document.querySelector('#js-home-owners-slide').classList.add('min-slide');
                document.querySelector('#style-detail__other-slide-nav').classList.add('min-slide-nav');
            }
        }

    }

    setScrollJump() {
        document.querySelectorAll('a[href^="#home-concept-type2"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                let href = anchor.getAttribute('href');
                let target = document.getElementById(href.replace('#', ''));
                let targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            });
        });
    }
}

export default HomeController;
